export default "__VITE_PUBLIC_ASSET__af5ff9ce__"